import { useEffect, useState } from 'react';
import RetryPanel from 'containers/partials/error-boundary/RetryPanel';
import Loader from 'components/loader/Loader';
import { useParams, useRouteMatch } from 'react-router-dom';
import { useStore } from 'stores/Store';
import useExercise from 'hooks/queries/useExercise';
import { ROUTE_USER_ENTITY_PROGRAMS_PROGRAM_EXERCISE } from 'routes/RouteList';
import { Panel } from 'components/panel';
import ExerciseCard from './ExerciseCard';
import usePostMessage from 'hooks/utils/usePostMessage';

const ProgramExercise = () => {
  const { entityId, exerciseId } = useParams();
  const active = useRouteMatch([ROUTE_USER_ENTITY_PROGRAMS_PROGRAM_EXERCISE]);

  const program = useStore(state => state.program);
  const { loading, error, fetchExercise } = useExercise(entityId);
  const { sendMessage } = usePostMessage();
  const [exercise, setExercise] = useState(null);

  useEffect(() => {
    const getExercise = async () => {
      const exercise = await fetchExercise(exerciseId);
      setExercise(exercise);
    };
    getExercise();
  }, [exerciseId]);

  useEffect(() => {
    if (exercise && !loading) {
      const data = {
        title: exercise?.title ?? '',
        description: '',
        canGoBack: true
      };
      sendMessage({ message: data });
    }
  }, [exercise, loading]);

  if (loading || !exercise) return <Loader />;
  if (error) return <RetryPanel />;

  return (
    <Panel active={active?.isExact}>
      <ExerciseCard entityId={entityId} program={program} exercise={exercise} />
    </Panel>
  );
};

export default ProgramExercise;
